<template>
  <div class="htable">
    <!-- 表头 -->
    <div class="htable-row" :style="{
      backgroundColor: HNewGameUIConfig.newGameUIType !==0?hcf.getMainColor() + '44':'#DAE9FE',
    }">
      <template v-for="(cell, i) in tabData.header" :key="'header-' + i">
        <div
            v-if="isMergedHeader(cell)"
            class="htable-cell merged-header"
            :style="getMergedHeaderStyle(cell)"
        >
          <div class="merged-title" :style="{
            border:HNewGameUIConfig.newGameUIType === 3?'#222 1px solid':'#fff 1px solid',
          }">{{ Object.keys(cell)[0] }}</div>
          <div class="merged-subcells">
            <div
                v-for="(sub, subIdx) in cell[Object.keys(cell)[0]]"
                :key="subIdx"
                class="merged-subcell"
                :style="getCellStyle(i, true)"
            >
              {{ formatCell(sub, i, true) }}
            </div>
          </div>
        </div>
        <div
            v-else
            class="htable-cell"
            :style="getCellStyle(i, true)"
        >
          {{ formatCell(cell, i, true) }}
        </div>
      </template>
    </div>

    <!-- 数据行 -->
    <div
        class="htable-row"
        v-for="(row, rowIndex) in tabData.list"
        :key="'row-' + rowIndex"
        :style="getRowStyle(rowIndex)"
        @click="handleRowClick(rowIndex, row)"
    >
      <template v-for="(cell, colIndex) in row" :key="'cell-' + rowIndex + '-' + colIndex">
        <div
            class="htable-cell"
            :style="getCellStyle(colIndex, false,cell)"
        >
          <slot v-if="colIndex === 0" name="firstCol" :active="props.targetRowIndex === rowIndex"/>
          {{ formatCell(cell, colIndex, false) }}
          <template v-if="colIndex === row.length - 1 && bringRightArrowCallBack">
            <van-icon name="arrow" class="arrow-icon" />
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  import {hcf} from "@/components/utils/HComFunctions.js";

  const props = defineProps({
    tabData: Object,
    targetColumnIndex: Number,
    targetColumnIndexColor: String,
    targetMoneyColumnIndex: Number,
    targetRowIndex: Number,
    targetRowIndexColor: String,
    bringRightArrowCallBack: Function,
    isDataSameColor: Boolean,
    isDateSimple: Boolean,
    headerColor: String,
    firstColSelectIcon: Object,
    firstColUnSelectIcon: Object,
  })
  const columnCount = computed(() => {
    // 处理 merged header 的情况：展开为总列数
    let count = 0
    props.tabData.header.forEach(cell => {
      if (typeof cell === 'object' && !Array.isArray(cell)) {
        const sub = Object.values(cell)[0]
        count += sub.length
      } else {
        count += 1
      }
    })
    return count
  })
  const isMergedHeader = (cell) =>
      typeof cell === 'object' && !Array.isArray(cell)

  const getCellStyle = (colIndex, isHeader,value = null) => {
    let color = isHeader?(props.headerColor??(HNewGameUIConfig.newGameUIType===3?'#ddd':'#333')):(HNewGameUIConfig.newGameUIType===3?'#ddd':'#333');
    if(props.targetMoneyColumnIndex === colIndex && !isHeader && value!==null){
      if(parseFloat(value)>=0){
        color = "#00BF71";
      }else{
        color = "#DC2B2B"
      }
    }
    if (!isHeader && colIndex === props.targetColumnIndex && props.targetColumnIndexColor) {
      color = props.targetColumnIndexColor
    }

    return {
      color,
      fontWeight: isHeader ? 'bold' : 'normal',
      padding: '5px',
      border: HNewGameUIConfig.newGameUIType===3?'1px solid #222':'1px solid #fff',
      width: `calc(100% / ${columnCount.value})`,
      boxSizing: 'border-box'
    }
  }

  const getMergedHeaderStyle = (cell) => {
    const subCells = Object.values(cell)[0]
    return {
      display: 'flex',
      flexDirection: 'column',
      flex: subCells.length
    }
  }

  const formatCell = (value, colIndex, isHeader) => {
    if (
        typeof value === 'string' &&
        value.includes('-') &&
        props.isDateSimple
    ) {
      const parts = value.split('-')
      if (parts.length === 3) {
        return `${parts[1]}/${parts[2]}`
      }
    }

    if (!isHeader && props.targetMoneyColumnIndex === colIndex) {
      const num = parseFloat(value)
      return isNaN(num) ? value : num.toFixed(2)
    }
    if(value>10000){
      value = (value/10000).toFixed(0) + "万";
    }
    if(value.indexOf('-')!==-1 && value.indexOf(':')!==-1){
      value = formatToMonthDayTime(value);
    }
    return value
  }
  function formatToMonthDayTime(datetimeStr) {
    const date = new Date(datetimeStr.replace(/-/g, '/')); // 替换是为了兼容 Safari
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day   = String(date.getDate()).padStart(2, '0');
    const hour  = String(date.getHours()).padStart(2, '0');
    const min   = String(date.getMinutes()).padStart(2, '0');
    const sec   = String(date.getSeconds()).padStart(2, '0');
    return `${month}/${day} ${hour}:${min}:${sec}`;
  }

  const getRowStyle = (rowIndex) => {
    const isTarget = props.targetRowIndex === rowIndex
    const bgColor = isTarget
        ? props.targetRowIndexColor
        : props.isDataSameColor || rowIndex % 2 === 0
            ? '#DAE9FE11'
            : HNewGameUIConfig.newGameUIType === 3?'#0000':'white'

    return {
      display: 'flex',
      backgroundColor: bgColor,
      cursor: props.bringRightArrowCallBack ? 'pointer' : 'default'
    }
  }

  const handleRowClick = (index, row) => {
    props.bringRightArrowCallBack?.(index, row)
  }
</script>

<style scoped>
  .htable {
    width: 100%;
    font-size: 11px;
    border-collapse: collapse;
  }

  .htable-row {
    display: flex;
  }

  .htable-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 30px;
    box-sizing: border-box;
  }
  .merged-header {
    flex-direction: column;
    align-items: stretch;
    border: none;
  }

  .merged-title {
    text-align: center;
    font-weight: bold;
    color:var(--ct-main-color);
    padding: 4px;
  }

  .merged-subcells {
    display: flex;
  }

  .merged-subcell {
    flex: 1;
    text-align: center;
  }

  .arrow-icon {
    margin-left: 6px;
    width: 12px;
    height: 12px;
  }

  /* 桌面: <style> 里的 font-size:11px / min-height:30px 被转 vw(表格字号放大到 ~35px、行高过高),
     拉回真实 px。HTable 为通用表格, 一处修复覆盖返水/注单/账变等所有用到它的详情表。 */
  @media (min-width: 1024px) {
    .htable {
      font-size: 13px;
    }
    .htable-cell {
      min-height: 34px;
    }
  }
</style>
